<template>
  <div class="edit-profile">

    <v-text-field
      :label="$t('userName')"
      v-model="user_name"
      outlined
    ></v-text-field>

    <v-text-field
      :label="$t('userId')"
      v-model="user_code"
      outlined
    >
    </v-text-field>

    <v-btn class="save-edit-btn" v-on:click="save_edit()">{{ $t('add') }}</v-btn>
  </div>

</template>
<script>
  import { bus } from '../../main'

  export default {
    data () {
      return {
        user_name :'',
        user_code :'',
        user_id : '',
        user_password: '',
        image_id: '',
        thumb_path: '',
        user_deviceNo: '',
        myprofile: '',
        error: []
      }
    },
    mounted () {
      this.profile()
    },
    methods: {
      profile () {
        var user_data = JSON.parse(localStorage.getItem('profile'))
        this.myprofile = user_data
        this.user_name = user_data.UserName
        this.user_code = user_data.UserCode
        this.user_id = user_data.UserId
        this.image_id = user_data.ImageId
        this.thumb_path = user_data.ThumbPath
        this.user_deviceNo = user_data.UserDeviceNo
        console.log(JSON.parse(localStorage.getItem('profile')))
        this.user_password = localStorage.getItem('password')
      },
      save_edit () {
        if (this.user_name == '' || this.user_name == ' ') {
          this.error.push(this.$t('userNameIsEmpty'))
        }
        if (this.user_code == '' || this.user_code == ' ') {
          this.error.push(this.$t('userIdIsEmpty'))
        }
        if (this.user_name != '' && this.user_code != '') {
          if (this.user_code.startsWith('@') == false) {
            var str1 = '@'
            this.user_code = str1.concat(this.user_code)
          }
          const send_data = {
            UserId:this.user_id,
            Password: this.user_password,
            UserName: this.user_name,
            UserCode: this.user_code
          }
          var self = this
          this.axios.post('/UpdateUserProfile', send_data, {})
            .then(response => {
              if (response.data.error == 0) {
                console.log('response edit', response)

                self.myprofile.UserName = self.user_name
                self.myprofile.UserCode = self.user_code
                //   const profile = {
                //   "UserName": this.user_name,
                //   "UserCode": this.user_code,
                //   "UserId" : this.user_id,
                //   "ImageId": this.image_id,
                //   "ThumbPath": this.thumb_path,
                //   "UserDeviceNo": this.user_deviceNo
                // }
                bus.$emit('show_toast', [3000, response.data.msg])

                console.log('profile', JSON.stringify(self.myprofile))
                localStorage.setItem('profile', JSON.stringify(self.myprofile))
              } else {
                bus.$emit('show_toast', [3000, response.data.msg])
              }
            }).catch(e => {

            })
        }
      }
    }

  }
</script>
